export const disableWindowScroll = (): void => {
  const bodyNode = document.getElementsByTagName('body');

  if (bodyNode[0]) {
    bodyNode[0].style.overflow = 'hidden';
  }
};

export const enableWindowScroll = (): void => {
  const bodyNode = document.getElementsByTagName('body');

  if (bodyNode[0]) {
    bodyNode[0].style.overflow = 'auto';
  }
};
